// Mock data for Crocus Hamam Spa

export const businessInfo = {
  name: "Crocus Hamam Spa",
  logo: "https://customer-assets.emergentagent.com/job_relax-retreat-1/artifacts/ac1dvnuk_crocus-hamami-masaj-spa-bostanci-kadikoy-erenkoy-umraniye-maltepe-atasehir-uskudar-kartal-pendik-goztepe-suadiye-kese-kopuk-masaji-isvec-medikal-sultan-dortel-4el-hamam-galeri-logo.png",
  email: "randevu@crocushamamspa.com",
  address: "Bostancı Mah. Bağdat Cad. Ata Apt. No:524/B 34744 Kadıköy/İstanbul",
  addressShort: "Bostancı Marmaray durağı karşısı",
  phones: [
    "+90 530 095 73 03",
    "+90 545 499 79 15"
  ],
  hours: "Pazartesi hariç her gün 11:00 - 22:00",
  parking: "Araçla gelenler çevredeki otoparklardan yararlanabilir."
};

export const packages = [
  {
    id: 1,
    name: "HAMAM PAKETİ",
    price: "",
    features: [
      "Hamam - Sauna - Buhar Odası",
      "20 Dakika Kese & Köpük Masajı"
    ],
    description: "Geleneksel Türk hamamı deneyimi. Kese ve köpük masajı ile vücudunuzdaki ölü derileri temizleyerek cildinizin yenilenmesini sağlar.",
    popular: false
  },
  {
    id: 2,
    name: "KLASİK MASAJ",
    price: "",
    features: [
      "Hamam - Sauna - Buhar Banyosu",
      "40 Dakika Klasik İsveç Masajı"
    ],
    description: "İsveç masajı tekniği ile kaslarınızın gevşemesini ve kan dolaşımınızın düzenlenmesini sağlar. Stres ve gerginliği azaltır.",
    popular: false
  },
  {
    id: 3,
    name: "ELİT PAKET",
    price: "",
    features: [
      "Hamam - Sauna - Buhar Banyosu",
      "Kese & Köpük Masajı",
      "40 Dakika Klasik İsveç Masajı"
    ],
    description: "Hamam ritüeli ve klasik isveç masajının birleşimi. Hem cilt yenilemesi hem de derin kas gevşemesi sağlar.",
    popular: true
  },
  {
    id: 4,
    name: "MIX PAKET",
    price: "",
    features: [
      "Hamam - Sauna - Buhar Banyosu",
      "Kese & Köpük Masajı",
      "50 Dakika Profesyonel Masaj"
    ],
    description: "Farklı masaj tekniklerinin birleşimi ile tam bir rahatlama deneyimi. Uzun süreli profesyonel masaj ile derin huzur.",
    popular: false
  },
  {
    id: 5,
    name: "SULTAN MASAJ",
    price: "",
    features: [
      "Hamam - Sauna - Buhar Banyosu",
      "Kese & Köpük Masajı",
      "50 Dakika 4 El Profesyonel Masaj"
    ],
    description: "En lüks hizmetimiz. İki masöz tarafından senkronize uygulanan 4 el masajı ile eşsiz bir rahatlama deneyimi yaşayın.",
    popular: false
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Hijyen & Temizlik",
    description: "En yüksek hijyen standartlarında hizmet sunuyoruz. Her müşteri sonrası ekipman ve alanlarımız detaylı dezenfekte ediliyor.",
    icon: "Sparkles"
  },
  {
    id: 2,
    title: "Aileye Uygun",
    description: "Kadınlar ve erkekler için ayrı randevu saatleri. Aile dostluk ve mahremiyete önem veriyoruz. Profesyonel ve etik hizmet anlayışı.",
    icon: "Users"
  },
  {
    id: 3,
    title: "Profesyonel Hizmet",
    description: "Alanında uzman, sertifikalı terapistler tarafından uygulanan masaj ve bakım hizmetleri. Yıllara dayanan tecrübe.",
    icon: "Award"
  },
  {
    id: 4,
    title: "Merkezi Konum",
    description: "Bostancı Marmaray durağı karşısında, ulaşımı çok kolay konumumuzda hizmetinizdeyiz. Kadıköy'ün merkezinde.",
    icon: "MapPin"
  }
];

export const services = [
  {
    id: 1,
    title: "Geleneksel Türk Hamamı",
    description: "Yüzyıllardır süregelen Türk hamam kültürü, vücut ve ruhunuzu arındırır. Sıcak taş üzerinde kese ve köpük uygulaması ile cildiniz yenilenir, toksinler atılır ve kan dolaşımınız düzenlenir.",
    videoUrl: "https://customer-assets.emergentagent.com/job_relax-retreat-1/artifacts/ihpd3qse_crocus-hamami-masaj-spa-bostanci-kadikoy-erenkoy-umraniye-maltepe-atasehir-uskudar-kartal-pendik-goztepe-suadiye-kese-kopuk-masaji-isvec-medikal-sultan-dortel_Hi_1.mp4",
    benefits: [
      "Ölü deri temizliği ve cilt yenilenmesi",
      "Kan dolaşımının düzenlenmesi",
      "Toksin atılımının hızlanması",
      "Derin rahatlama ve stres azaltma",
      "Gözeneklerin açılması ve temizlenmesi"
    ]
  },
  {
    id: 2,
    title: "Klasik İsveç Masajı",
    description: "Dünyaca ünlü İsveç masajı tekniği, kaslarınızdaki gerginliği çözer, kan dolaşımını düzenler ve bedeninizi rahatlatır. Orta basınçlı bu masaj türü hem rahatlık hem de terapi sağlar.",
    videoUrl: "https://customer-assets.emergentagent.com/job_relax-retreat-1/artifacts/ta0rtbj9_crocus-hamami-masaj-spa-bostanci-kadikoy-erenkoy-umraniye-maltepe-atasehir-uskudar-kartal-pendik-goztepe-suadiye-kese-kopuk-masaji-isvec-medikal-sultan-dortel_Hi_2.mp4",
    benefits: [
      "Kas gerginliklerinin çözülmesi",
      "Kan ve lenf dolaşımının iyileştirilmesi",
      "Stres ve anksiyetenin azaltılması",
      "Uyku kalitesinin artırılması",
      "Genel vücut rahatlığı"
    ]
  },
  {
    id: 3,
    title: "Profesyonel Masaj",
    description: "Farklı masaj tekniklerinin birleşimi ile size özel hazırlanan profesyonel masaj. Derin doku masajı, aromaterapi ve refleksoloji unsurları bir araya getirilerek optimal sonuç elde edilir.",
    videoUrl: "https://customer-assets.emergentagent.com/job_relax-retreat-1/artifacts/nwnrwpw8_crocus-hamami-masaj-spa-bostanci-kadikoy-erenkoy-umraniye-maltepe-atasehir-uskudar-kartal-pendik-goztepe-suadiye-kese-kopuk-masaji-isvec-medikal-sultan-dortel_Hi_3.mp4",
    benefits: [
      "Derin kas rahatlması",
      "Kronik ağrıların azaltılması",
      "Enerji seviyesinin artırılması",
      "Vücut farkındalığının geliştirilmesi",
      "Fiziksel ve zihinsel dengenin sağlanması"
    ]
  },
  {
    id: 4,
    title: "4 El Sultan Masajı",
    description: "En lüks masaj deneyimimiz. İki profesyonel terapist tarafından mükemmel senkronizasyonla uygulanan 4 el masajı, bedeninize ve zihninize eşsiz bir huzur ve denge getirir. Osmanlı saraylarının efsanevi masaj geleneği.",
    videoUrl: "https://customer-assets.emergentagent.com/job_relax-retreat-1/artifacts/z26etwyu_crocus-hamami-masaj-spa-bostanci-kadikoy-erenkoy-umraniye-maltepe-atasehir-uskudar-kartal-pendik-goztepe-suadiye-kese-kopuk-masaji-isvec-medikal-sultan-dortel_Hi_4.mp4",
    benefits: [
      "Eşsiz rahatlama deneyimi",
      "Derin meditasyon seviyesinde rahatlama",
      "Tüm vücutta eşzamanlı rahatlama",
      "Özel ve lüks bir deneyim",
      "Maksimum stres giderme"
    ]
  },
  {
    id: 5,
    title: "Sauna & Buhar Odası",
    description: "Finlandiya saunası ve Türk buhar odası ile toksinlerinizi atın, bağışıklık sisteminizi güçlendirin. Her paketimizde yer alan bu hizmet, masaj öncesi vücudunuzu hazırlar.",
    videoUrl: "https://customer-assets.emergentagent.com/job_relax-retreat-1/artifacts/183uhmpl_crocus-hamami-masaj-spa-bostanci-kadikoy-erenkoy-umraniye-maltepe-atasehir-uskudar-kartal-pendik-goztepe-suadiye-kese-kopuk-masaji-isvec-medikal-sultan-dortel_Hi_5.mp4",
    benefits: [
      "Toksin atılımı ve detoks",
      "Bağışıklık sisteminin güçlenmesi",
      "Solunum yollarının temizlenmesi",
      "Cildin derinlemesine temizlenmesi",
      "Kasların ısınması ve gevşemesi"
    ]
  }
];

export const gallery = [
  "https://customer-assets.emergentagent.com/job_relax-retreat-1/artifacts/3no4c89j_crocus-hamami-masaj-spa-bostanci-kadikoy-erenkoy-umraniye-maltepe-atasehir-uskudar-kartal-pendik-goztepe-suadiye-kese-kopuk-masaji-isvec-medikal-sultan-dortel-4el-hamam-galeri-01.png",
  "/galeri/crocus-hamami-masaj-spa-bostanci-kadikoy-erenkoy-umraniye-maltepe-atasehir-uskudar-kartal-pendik-goztepe-suadiye-kese-kopuk-masaji-isvec-medikal-sultan-dortel-4el-hamam-galeri-03.png",
  "/galeri/crocus-hamami-masaj-spa-bostanci-kadikoy-erenkoy-umraniye-maltepe-atasehir-uskudar-kartal-pendik-goztepe-suadiye-kese-kopuk-masaji-isvec-medikal-sultan-dortel-4el-hamam-galeri-04.png",
  "/galeri/crocus-hamami-masaj-spa-bostanci-kadikoy-erenkoy-umraniye-maltepe-atasehir-uskudar-kartal-pendik-goztepe-suadiye-kese-kopuk-masaji-isvec-medikal-sultan-dortel-4el-hamam-galeri-05.png",
  "/galeri/crocus-hamami-masaj-spa-bostanci-kadikoy-erenkoy-umraniye-maltepe-atasehir-uskudar-kartal-pendik-goztepe-suadiye-kese-kopuk-masaji-isvec-medikal-sultan-dortel-4el-hamam-galeri-06.png",
  "/galeri/crocus-hamami-masaj-spa-bostanci-kadikoy-erenkoy-umraniye-maltepe-atasehir-uskudar-kartal-pendik-goztepe-suadiye-kese-kopuk-masaji-isvec-medikal-sultan-dortel-4el-hamam-galeri-08.png",
  "/galeri/crocus-hamami-masaj-spa-bostanci-kadikoy-erenkoy-umraniye-maltepe-atasehir-uskudar-kartal-pendik-goztepe-suadiye-kese-kopuk-masaji-isvec-medikal-sultan-dortel-4el-hamam-galeri-11.png",
  "/galeri/crocus-hamami-masaj-spa-bostanci-kadikoy-erenkoy-umraniye-maltepe-atasehir-uskudar-kartal-pendik-goztepe-suadiye-kese-kopuk-masaji-isvec-medikal-sultan-dortel-4el-hamam-galeri-16.png",
  "/galeri/crocus-hamami-masaj-spa-bostanci-kadikoy-erenkoy-umraniye-maltepe-atasehir-uskudar-kartal-pendik-goztepe-suadiye-kese-kopuk-masaji-isvec-medikal-sultan-dortel-4el-hamam-galeri-17.png",
  "/galeri/crocus-hamami-masaj-spa-bostanci-kadikoy-erenkoy-umraniye-maltepe-atasehir-uskudar-kartal-pendik-goztepe-suadiye-kese-kopuk-masaji-isvec-medikal-sultan-dortel-4el-hamam-galeri-19.png",
  "/galeri/crocus-hamami-masaj-spa-bostanci-kadikoy-erenkoy-umraniye-maltepe-atasehir-uskudar-kartal-pendik-goztepe-suadiye-kese-kopuk-masaji-isvec-medikal-sultan-dortel-4el-hamam-galeri-20.png",
  "/galeri/crocus-hamami-masaj-spa-bostanci-kadikoy-erenkoy-umraniye-maltepe-atasehir-uskudar-kartal-pendik-goztepe-suadiye-kese-kopuk-masaji-isvec-medikal-sultan-dortel-4el-hamam-galeri-22.png",
  "/galeri/crocus-hamami-masaj-spa-bostanci-kadikoy-erenkoy-umraniye-maltepe-atasehir-uskudar-kartal-pendik-goztepe-suadiye-kese-kopuk-masaji-isvec-medikal-sultan-dortel-4el-hamam-galeri-23.png",
  "/galeri/crocus-hamami-masaj-spa-bostanci-kadikoy-erenkoy-umraniye-maltepe-atasehir-uskudar-kartal-pendik-goztepe-suadiye-kese-kopuk-masaji-isvec-medikal-sultan-dortel-4el-hamam-galeri-25.png",
  "/galeri/crocus-hamami-masaj-spa-bostanci-kadikoy-erenkoy-umraniye-maltepe-atasehir-uskudar-kartal-pendik-goztepe-suadiye-kese-kopuk-masaji-isvec-medikal-sultan-dortel-4el-hamam-galeri-32.png",
  "/galeri/crocus-hamami-masaj-spa-bostanci-kadikoy-erenkoy-umraniye-maltepe-atasehir-uskudar-kartal-pendik-goztepe-suadiye-kese-kopuk-masaji-isvec-medikal-sultan-dortel-4el-hamam-galeri-33.png",
  "/galeri/crocus-hamami-masaj-spa-bostanci-kadikoy-erenkoy-umraniye-maltepe-atasehir-uskudar-kartal-pendik-goztepe-suadiye-kese-kopuk-masaji-isvec-medikal-sultan-dortel-4el-hamam-galeri-34.png",
  "/galeri/crocus-hamami-masaj-spa-bostanci-kadikoy-erenkoy-umraniye-maltepe-atasehir-uskudar-kartal-pendik-goztepe-suadiye-kese-kopuk-masaji-isvec-medikal-sultan-dortel-4el-hamam-galeri-36.png",
  "/galeri/crocus-hamami-masaj-spa-bostanci-kadikoy-erenkoy-umraniye-maltepe-atasehir-uskudar-kartal-pendik-goztepe-suadiye-kese-kopuk-masaji-isvec-medikal-sultan-dortel-4el-hamam-galeri-37.png",
  "/galeri/crocus-hamami-masaj-spa-bostanci-kadikoy-erenkoy-umraniye-maltepe-atasehir-uskudar-kartal-pendik-goztepe-suadiye-kese-kopuk-masaji-isvec-medikal-sultan-dortel-4el-hamam-galeri-38.png",
  "/galeri/crocus-hamami-masaj-spa-bostanci-kadikoy-erenkoy-umraniye-maltepe-atasehir-uskudar-kartal-pendik-goztepe-suadiye-kese-kopuk-masaji-isvec-medikal-sultan-dortel-4el-hamam-galeri-39.png",
  "/galeri/crocus-hamami-masaj-spa-bostanci-kadikoy-erenkoy-umraniye-maltepe-atasehir-uskudar-kartal-pendik-goztepe-suadiye-kese-kopuk-masaji-isvec-medikal-sultan-dortel-4el-hamam-galeri-40.png"
];

export const heroVideos = [
  "https://customer-assets.emergentagent.com/job_relax-retreat-1/artifacts/is169935_crocus-hamami-masaj-spa-bostanci-kadikoy-erenkoy-umraniye-maltepe-atasehir-uskudar-kartal-pendik-goztepe-suadiye-kese-kopuk-masaji-isvec-medikal-sultan-dortel-4el-hamam-SV-01.mp4",
  "https://customer-assets.emergentagent.com/job_relax-retreat-1/artifacts/9w0ej1h2_crocus-hamami-masaj-spa-bostanci-kadikoy-erenkoy-umraniye-maltepe-atasehir-uskudar-kartal-pendik-goztepe-suadiye-kese-kopuk-masaji-isvec-medikal-sultan-dortel-4el-hamam-SV-02.mp4",
  "https://customer-assets.emergentagent.com/job_relax-retreat-1/artifacts/eymhket5_crocus-hamami-masaj-spa-bostanci-kadikoy-erenkoy-umraniye-maltepe-atasehir-uskudar-kartal-pendik-goztepe-suadiye-kese-kopuk-masaji-isvec-medikal-sultan-dortel-4el-hamam-SV-06.mp4",
  "https://customer-assets.emergentagent.com/job_relax-retreat-1/artifacts/2e1c1vmr_crocus-hamami-masaj-spa-bostanci-kadikoy-erenkoy-umraniye-maltepe-atasehir-uskudar-kartal-pendik-goztepe-suadiye-kese-kopuk-masaji-isvec-medikal-sultan-dortel-4el-hamam-SV-07.mp4",
  "https://customer-assets.emergentagent.com/job_relax-retreat-1/artifacts/imn2wy6y_crocus-hamami-masaj-spa-bostanci-kadikoy-erenkoy-umraniye-maltepe-atasehir-uskudar-kartal-pendik-goztepe-suadiye-kese-kopuk-masaji-isvec-medikal-sultan-dortel-4el-hamam-SV-08.mp4",
  "https://customer-assets.emergentagent.com/job_relax-retreat-1/artifacts/qqvtodsl_crocus-hamami-masaj-spa-bostanci-kadikoy-erenkoy-umraniye-maltepe-atasehir-uskudar-kartal-pendik-goztepe-suadiye-kese-kopuk-masaji-isvec-medikal-sultan-dortel-4el-hamam-SV-10.mp4"
];